export class ChannelUser {
    public ChannelId!: string;
    public GroupId!: number;
    public GroupName!: string;
}
